import { ShareInformationPage } from "@modules/investor-relations/pages/ShareInformationPage";
import { useLoaderData } from "@remix-run/react";

export default function ShareInformation() {
  useLoaderData();

  return <ShareInformationPage />;
}
